<template>
    <span class="badge" :class="type">
    {{ text }}
    </span>
</template>

<script>
export default {
    props: ['type','title'],
    computed: {
        text(){
            return this.title.toUpperCase();
        }
    }
}
</script>

<style scoped>
.badge {
  background-color: #f1a605;
  color: #000;
  border-radius: 30px;
  padding: 0.5rem 1.5rem;
  display: inline-block;
  margin-right: 0.5rem;
}
@media(max-width: 768px){
    .badge  {
    padding: 0.5rem 1.5rem;
    font-size: 12px;
    margin: 5px;
}
}
</style>